export default __webpack_public_path__ + "static/media/ITOAM-bothbooked.c82297a1.svg";